import { onCleanup, onMount } from 'solid-js'

/**
 * Runs a callback when a pointer lands outside the element.
 *
 * @param getElement - Returns the container element once mounted.
 * @param onOutside - Called for pointer-downs outside the element.
 */
export function createOutsidePointerDown(
   getElement: () => HTMLElement | undefined,
   onOutside: () => void,
) {
   onMount(() => {
      /**
       * Forwards outside pointer-downs to the callback.
       *
       * @param event - The pointer event.
       */
      const handlePointerDown = (event: PointerEvent) => {
         const element = getElement()
         if (element && !element.contains(event.target as Node)) {
            onOutside()
         }
      }
      document.addEventListener('pointerdown', handlePointerDown)
      onCleanup(() => {
         document.removeEventListener('pointerdown', handlePointerDown)
      })
   })
}
